<ng-container *ngIf="isLegacy; else reportType">
  <div class="flex flex-col flex-auto w-full p-8 xs:p-2">
    <div class="flex flex-wrap w-full">
      <div class="flex items-center justify-between w-full my-4 px-4 xs:pr-0">
        <div class="mr-6">
          <h2 class="m-0">
            <span *ngIf="!editingName" (dblclick)="editName()">{{
              dashboard?.name?.trim()?.length ? dashboard?.name : 'Untitled'
            }}</span>
            <mat-form-field class="treo-mat-no-subscript min-w-160" *ngIf="editingName">
              <mat-label></mat-label>
              <input matInput [(ngModel)]="dashboardName" required />
              <button mat-icon-button matSuffix (click)="editName()">
                <mat-icon [svgIcon]="'cancel'"></mat-icon>
              </button>
              <button mat-icon-button matSuffix (click)="saveDashboard()" [disabled]="!dashboard?.name">
                <mat-icon [svgIcon]="'save'"></mat-icon>
              </button>
            </mat-form-field>
          </h2>
          <div class="text-secondary tracking-tight">Keep track of what's happening.</div>
        </div>
        <!-- Action buttons -->
        <div class="flex items-center">
          <ng-container *ngIf="editMode">
            <button mat-icon-button (click)="toggleEditMode()" matTooltip="Cancel">
              <mat-icon class="edit-icon" [svgIcon]="'cancel'"></mat-icon>
            </button>
            <button mat-icon-button (click)="saveDashboard()" matTooltip="Save" [disabled]="!dashboard?.name">
              <mat-icon class="edit-icon" [svgIcon]="'save'"></mat-icon>
            </button>
          </ng-container>
          <button class="mt-2 xs:hidden mr-3" mat-stroked-button (click)="openProjectsFilterDialog()">
            <ng-container *ngIf="!runningFilter">
              <mat-icon class="rotate-90 mirror" [svgIcon]="'tune'"></mat-icon>
              Filter
            </ng-container>
            <mat-progress-spinner *ngIf="runningFilter" [diameter]="24" [mode]="'indeterminate'">
            </mat-progress-spinner>
          </button>
          <button
            class="more-menu"
            [appAuthorize]="canShowThreeDotMenu()"
            mat-icon-button
            [matMenuTriggerFor]="moreMenu"
          >
            <mat-icon [svgIcon]="'more_vert'"></mat-icon>
          </button>
          <mat-menu #moreMenu="matMenu">
            <button
              *ngIf="!editMode"
              [appAuthorize]="
                (newPermissionsEnabled$ | async) ? NewPermission.DASHBOARDS_EDIT : Permission.DASHBOARDS_CREATE_EDIT
              "
              (click)="toggleEditMode()"
              [matTooltip]="'Edit Dashboard'"
              mat-menu-item
            >
              <mat-icon [svgIcon]="'edit'"></mat-icon>
              Edit Dashboard
            </button>
            <button
              mat-menu-item
              (click)="deleteDashboard()"
              [appAuthorize]="
                (newPermissionsEnabled$ | async) ? NewPermission.DASHBOARDS_DELETE : Permission.DASHBOARDS_DELETE
              "
              [matTooltip]="'Delete Dashboard'"
            >
              <mat-icon [svgIcon]="'delete'"></mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <ng-container *ngIf="!editMode">
        <div class="flex flex-auto w-full" *ngFor="let chartRow of charts; let rowIndex = index">
          <ng-container
            *ngFor="let chartDef of chartRow; let colIndex = index; let firstCol = first; let lastCol = last"
          >
            <div
              class="flex flex-col flex-auto bg-card shadow-md rounded overflow-hidden m-2"
              [ngClass]="{ 'w-1': chartRow.length == 1, 'w-1/2': chartRow.length == 2, 'w-1/3': chartRow.length == 3 }"
            >
              <chart
                [hideEdit]="!canEditDashboard()"
                [chartDef]="chartDef"
                (editChart)="editChart(rowIndex, colIndex, chartDef, true)"
              ></chart>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="editMode">
        <div
          class="flex flex-auto w-full"
          *ngFor="let chartRow of charts; let rowIndex = index; let firstRow = first; let lastRow = last"
        >
          <ng-container
            *ngFor="let chartDef of chartRow; let colIndex = index; let firstCol = first; let lastCol = last"
          >
            <div class="flex flex-col flex-auto bg-card shadow-md rounded overflow-hidden m-2 min-h-32 text-center p-8">
              <h6 (click)="editChart(rowIndex, colIndex, chartDef)">{{ chartDef?.title }}</h6>
            </div>
            <button
              class="remove-email-field"
              type="button"
              *ngIf="!(firstRow && lastRow)"
              mat-icon-button
              (click)="removeChart(rowIndex, colIndex)"
              matTooltip="Remove"
            >
              <mat-icon [svgIcon]="'cancel'"></mat-icon>
            </button>
            <button
              class="add-email-field"
              type="button"
              *ngIf="lastCol"
              mat-icon-button
              (click)="addChart(rowIndex)"
              matTooltip="Add"
            >
              <mat-icon [svgIcon]="'add_circle'"></mat-icon>
            </button>
            <button
              class="add-email-field"
              type="button"
              *ngIf="lastRow && lastCol"
              mat-icon-button
              (click)="addRow()"
              matTooltip="Add"
            >
              <mat-icon [svgIcon]="'library_add'"></mat-icon>
            </button>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<ng-template #reportType>
  <app-dashboard-details-report
    [dashboard]="dashboard"
    [fields]="data.fieldDefs"
    [options]="data.options"
  ></app-dashboard-details-report>
</ng-template>
